import React from "react";

function Emision() {
  return <div>Emision</div>;
}

export default Emision;
